'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'tooth';
var width = 448;
var height = 512;
var aliases = [129463];
var unicode = 'f5c9';
var svgPathData = 'M392.9 225.3c-14.31 19.97-22.47 45.16-25.62 79.28c-2.875 31.81-7.374 73.81-16.72 116.1l-6.187 27.66C340.3 466.9 324.3 480 305.5 480c-18.62 0-34.56-12.84-38.75-31.22l-27.09-112.3c-1.875-7.656-8.312-13.03-15.65-13.03c-7.343 0-13.78 5.375-15.69 13.09l-27.09 112.5C176.9 467.2 160.9 480 142.5 480c-18.87 0-34.87-13.09-38.9-31.81L97.39 420.7c-9.343-42.28-13.84-84.28-16.72-116.1c-3.062-33.97-11.22-59.16-25.62-79.25c-21.09-29.59-28.03-66.06-19.5-102.7c10.03-42.53 42.87-77.06 83.74-87.1C145.5 27.73 173.3 34.92 201.7 56.07l.6874 .5c9.187 6.937 48.09 32.69 62.37 42.06c7.405 4.844 9.437 14.78 4.593 22.16c-4.875 7.406-14.9 9.406-22.15 4.594c-1.937-1.281-65.49-44.5-65.49-44.5C162.6 66.57 144.4 61.1 127.5 65.54C97.96 73.45 74.05 98.73 66.71 129.9C60.3 157.4 65.4 184.7 81.08 206.7c17.84 24.87 27.84 55.06 31.47 94.97c2.781 30.91 7.124 71.56 16.09 112l6.187 27.59c1.719 7.937 13.37 8.031 15.25 .2187l27.12-112.6c5.406-22.12 24.65-37.53 46.78-37.53s41.37 15.41 46.75 37.47l27.15 112.6c1.781 7.937 13.53 7.719 15.25-.0313l6.187-27.75c8.968-40.44 13.31-81.09 16.09-111.1c3.718-40.06 13.75-70.25 31.5-94.1c15.72-21.97 20.81-49.25 14.34-76.81c-7.437-31.19-31.34-56.47-60.93-64.34c-12.53-3.437-25.84-1.156-40.65 6.937c-7.749 4.187-17.47 1.344-21.72-6.406c-4.218-7.781-1.344-17.47 6.406-21.72c22.09-12.03 43.68-15.28 64.27-9.719c40.71 10.87 73.62 45.37 83.74 87.87C421 159.2 414.1 195.7 392.9 225.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTooth = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;